export const authorizationsTags = [
  'AuthorizationTransitions',
] as const;
